import Device from '../../../../../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '30%',
    [Device.mobile]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      width: '100%'
    }
  },
  noTitle: {
    marginLeft: 0
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20
  },
  detailValue: {
    margin: '1px 10px 0px 0px',
    [Device.mobile]: {
      margin: '0px 5px',
      textAlign: 'left',
      whiteSpace: 'normal'
    }
  }
};
